"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _home = _interopRequireDefault(require("cccisd-icons/svg/home"));
var _cog = _interopRequireDefault(require("cccisd-icons/svg/cog"));
var _bell = _interopRequireDefault(require("cccisd-icons/svg/bell2"));
var _user = _interopRequireDefault(require("cccisd-icons/svg/user"));
var _users = _interopRequireDefault(require("cccisd-icons/svg/users"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/svg/arrow-left6"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _exit = _interopRequireDefault(require("cccisd-icons/svg/exit"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/svg/checkmark"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross4"));
var _Dropdown = _interopRequireDefault(require("./Dropdown.js"));
var _MobileLink = _interopRequireDefault(require("./MobileLink.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useWidth = _interopRequireDefault(require("./useWidth.js"));
var _CustomLink = _interopRequireDefault(require("./CustomLink.js"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _parseAppDefsNav = _interopRequireDefault(require("./parseAppDefsNav.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq.js"));
var _AlertButton = _interopRequireDefault(require("cccisd-laravel-nexus/dist/components/AlertButton"));
var _window, _window2, _window3; // Need to import directly from dist to keep bundle size small
// Note: If the path ever changes (in cccisd-laravel-nexus), this
// import path will need to be updated to reflect that change
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = (_window = window) === null || _window === void 0 ? void 0 : _window.cccisd.boilerplate;
var Fortress = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.cccisd.fortress;
var AppDefs = (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.cccisd.appDefs;
var isSuperUser = Fortress.isSuperUser();
var isQuestAdmin = Fortress.hasAnyAccess('quest.admin', 'anyTarget');
var isActive = function isActive(item) {
  if (item.activeRegex) {
    var regex = new RegExp(item.activeRegex);
    return regex.test(window.location.pathname);
  }
  return window.location.pathname.startsWith(item.url);
};
var Header = function Header(props) {
  var containerClassName = props.containerClassName,
    wrapperClassName = props.wrapperClassName,
    logoClassName = props.logoClassName,
    logoLink = props.logoLink,
    isDarkPrimaryNav = props.isDarkPrimaryNav;
  var navLinks = typeof props.primaryNavLinks === 'string' ? (0, _parseAppDefsNav["default"])(props.primaryNavLinks) : props.primaryNavLinks;
  if (isSuperUser || isQuestAdmin) {
    var hasQuestUserGuide = navLinks.find(function (item) {
      return item.label === 'Quest User Guide';
    });
    if (!hasQuestUserGuide) {
      navLinks.push({
        label: 'Quest User Guide',
        url: '/guide',
        highlight: ['guide'],
        activeRegex: '^/x?guide.*'
      });
    }
  }
  var primaryNavLinks = (0, _uniq2["default"])(navLinks);
  var secondaryNavLinks = typeof props.secondaryNavLinks === 'string' ? (0, _parseAppDefsNav["default"])(props.secondaryNavLinks) : props.secondaryNavLinks;
  var primaryBarRef = (0, _react.useRef)();
  var primaryBarMeterRef = (0, _react.useRef)();
  var secondaryBarRef = (0, _react.useRef)();
  var secondaryBarMeterRef = (0, _react.useRef)();
  var width = (0, _useWidth["default"])();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    primaryNavWidth = _useState2[0],
    setPrimaryNavWidth = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    primaryNavLinksWidth = _useState4[0],
    setPrimaryNavLinksWidth = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    secondaryNavWidth = _useState6[0],
    setSecondaryNavWidth = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    secondaryNavLinksWidth = _useState8[0],
    setSecondaryNavLinksWidth = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showMobileBar = _useState10[0],
    setShowMobileBar = _useState10[1];
  var isCollapse = width < 768;
  (0, _react.useEffect)(function () {
    if (isCollapse) {
      return;
    }

    // primary
    var primaryRo = new ResizeObserver(function (entries) {
      if (entries.length === 1) {
        setPrimaryNavWidth(entries[0].contentRect.width);
      }
    });
    primaryRo.observe(primaryBarRef.current);
    if (primaryBarMeterRef.current) {
      var sizes = [];
      var children = primaryBarMeterRef.current.children;
      for (var i = 0; i < children.length; i++) {
        sizes.push(children[i].getBoundingClientRect().width);
      }
      setPrimaryNavLinksWidth(sizes);
    }

    // secondary
    var secondaryRo = new ResizeObserver(function (entries) {
      if (entries.length === 1) {
        setSecondaryNavWidth(entries[0].contentRect.width);
      }
    });
    if (secondaryBarRef.current) {
      secondaryRo.observe(secondaryBarRef.current);
    }
    if (secondaryBarMeterRef.current) {
      var _sizes = [];
      var _children = secondaryBarMeterRef.current.children;
      for (var _i = 0; _i < _children.length; _i++) {
        _sizes.push(_children[_i].getBoundingClientRect().width);
      }
      setSecondaryNavLinksWidth(_sizes);
    }
    return function () {
      primaryRo.disconnect();
      secondaryRo.disconnect();
    };
  }, [isCollapse, props.primaryNavLinks, props.secondaryNavLinks]);
  var returnToUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e && e.preventDefault();
            _context.next = 3;
            return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.user.logoutAs'));
          case 3:
            window.location.href = Boilerplate.url(Fortress.settings.config.after_login_url);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function returnToUser(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var actualPrimaryNavLinks = (0, _react.useMemo)(function () {
    var visible = [];
    var hidden = [];
    var availableWidth = primaryNavWidth - 100;
    if (primaryNavWidth === 0 || primaryNavLinksWidth.length !== primaryNavLinks.length) {
      return [];
    }
    var totalLinksWidth = primaryNavLinksWidth.reduce(function (sum, item) {
      return sum + item;
    }, 0);
    if (totalLinksWidth < primaryNavWidth) {
      return primaryNavLinks;
    }
    var totalWidth = 0;
    for (var i = 0; i < primaryNavLinks.length; i++) {
      var link = primaryNavLinks[i];
      var size = primaryNavLinksWidth[i] || 0;
      totalWidth += size;
      if (totalWidth > availableWidth) {
        hidden.push(link);
      } else {
        visible.push(link);
      }
    }
    if (hidden.length > 0) {
      visible.push({
        label: 'More',
        url: '/more...',
        children: hidden
      });
    }
    return visible;
  }, [props.primaryNavLinks, primaryNavWidth, primaryNavLinksWidth]);
  var actualSecondaryNavLinks = (0, _react.useMemo)(function () {
    var visible = [];
    var hidden = [];
    var availableWidth = secondaryNavWidth - 100;
    if (secondaryNavWidth === 0 || secondaryNavLinksWidth.length !== secondaryNavLinks.length) {
      return [];
    }
    var totalLinksWidth = secondaryNavLinksWidth.reduce(function (sum, item) {
      return sum + item;
    }, 0);
    if (totalLinksWidth < secondaryNavWidth) {
      return secondaryNavLinks;
    }
    var totalWidth = 0;
    for (var i = 0; i < secondaryNavLinks.length; i++) {
      var link = secondaryNavLinks[i];
      var size = secondaryNavLinksWidth[i] || 0;
      totalWidth += size;
      if (totalWidth > availableWidth) {
        hidden.push(link);
      } else {
        visible.push(link);
      }
    }
    if (hidden.length > 0) {
      visible.push({
        label: 'More',
        url: '/more...',
        children: hidden
      });
    }
    return visible;
  }, [props.secondaryNavLinks, secondaryNavWidth, secondaryNavLinksWidth]);
  var switchRole = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e, pawnId) {
      var response, redirectUrl;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e && e.preventDefault();
            if (!(pawnId === Fortress.user.pawnId)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _context2.next = 5;
            return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.user.changeTo'), {
              pawn: pawnId
            });
          case 5:
            response = _context2.sent;
            if (!(response.status !== 200 || !response.data.data)) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return");
          case 8:
            redirectUrl = response.data.data.hasIncompleteSiteRegistration ? Boilerplate.url('/account/registrationSurvey') : Boilerplate.url(Fortress.settings.config.after_login_url);
            window.location.href = redirectUrl;
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function switchRole(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var renderPrimaryNavMeter = function renderPrimaryNavMeter() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].primaryNavMeter,
      ref: primaryBarMeterRef
    }, primaryNavLinks.map(function (item) {
      var Icon = item.icon;
      return /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
        key: item.url + item.handle,
        to: item.url,
        className: _style["default"].link
      }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement("span", null, item.label), item.children && /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));
    }));
  };
  var renderSecondaryNavMeter = function renderSecondaryNavMeter() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].secondaryNavMeter,
      ref: secondaryBarMeterRef
    }, secondaryNavLinks.map(function (item) {
      var Icon = item.icon;
      return /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
        key: item.url + item.handle,
        to: item.url,
        className: _style["default"].link
      }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement("span", null, item.label), item.children && /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));
    }));
  };
  var renderNav = function renderNav(links) {
    var _renderChildren = function renderChildren(children) {
      return children.map(function (item) {
        var Icon = item.icon;
        if (item.children) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: item.url + item.handle,
            className: _style["default"].menuLink
          }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement("div", null, item.label), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].childrenIcon
          }, item.children && /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
            spaceLeft: true
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].submenu
          }, _renderChildren(item.children)));
        }
        return /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
          key: item.url + item.handle,
          to: item.url,
          className: (0, _classnames["default"])(_style["default"].menuLink, isActive(item) && _style["default"].active)
        }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), item.label);
      });
    };
    return links.map(function (item) {
      var Icon = item.icon;
      if (item.children) {
        return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
          key: item.url + item.handle,
          title: item.label,
          Icon: Icon,
          isActive: item.children.some(function (child) {
            return isActive(child);
          })
        }, _renderChildren(item.children));
      }
      return /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], _extends({
        key: item.url + item.handle,
        to: item.url,
        className: (0, _classnames["default"])(_style["default"].link, isActive(item) && _style["default"].active)
      }, item.action ? {
        onClick: function onClick(e) {
          e.preventDefault();
          item.action();
        }
      } : {}), Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].linkLabel
      }, item.label));
    });
  };
  var renderIconNav = function renderIconNav() {
    var showHomeAction = props.showHomeAction,
      showAdminAction = props.showAdminAction,
      showAlertAction = props.showAlertAction,
      additionalIconLinks = props.additionalIconLinks;
    var hasAlertAction = Boolean(showAlertAction && Fortress.auth());
    var hasAdminActions = showAdminAction && [Fortress.hasAccess('debug.admin'), Fortress.hasAccess('appdefs.debug'), Fortress.hasAccess('logs.admin'), Fortress.hasAccess('appdefs.logs'), Fortress.hasAccess('quest.admin'), Fortress.hasAnyAccess(['quest.admin', 'quest.code', 'quest.deploy', 'quest.design', 'quest.export', 'quest.permissions', 'quest.status', 'quest.view_data'], 'anyTarget'), Fortress.hasAccess('resources.admin'), Fortress.hasAccess('shortUrls.admin'), Fortress.hasAccess('shorturls.admin'),
    // handles typo case for backwards compatibiliy
    Fortress.hasAnyAccess(['licensing.admin', 'licensing.licenses', 'licensing.courses', 'licensing.logs', 'licensing.vouchers', 'licensing.products']), Fortress.hasAccess('appdefs.admin')].some(Boolean);
    if (!showHomeAction && !hasAdminActions && !hasAlertAction && additionalIconLinks.length === 0) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].iconNav, isDarkPrimaryNav && _style["default"].dark)
    }, showHomeAction && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Go Home",
      tippyProps: {
        delay: [500, null]
      }
    }, /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: logoLink,
      className: _style["default"].link
    }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement(_home["default"], null))), hasAdminActions && /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
      Icon: _cog["default"],
      position: isCollapse ? 'right' : 'left'
    }, (Fortress.hasAccess('debug.admin') || Fortress.hasAccess('appdefs.debug')) && /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: "/appdefs/about",
      className: _style["default"].menuLink
    }, "About"), (Fortress.hasAccess('logs.admin') || Fortress.hasAccess('appdefs.logs')) && /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: "/appdefs/logs",
      className: _style["default"].menuLink
    }, "Logs"), (Fortress.hasAccess('debug.admin') || Fortress.hasAccess('appdefs.debug') || Fortress.hasAccess('logs.admin') || Fortress.hasAccess('appdefs.logs')) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].divider
    }), Fortress.hasAnyAccess(['quest.admin', 'quest.code', 'quest.deploy', 'quest.design', 'quest.export', 'quest.permissions', 'quest.status', 'quest.view_data'], 'anyTarget') && /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: "/quest",
      className: _style["default"].menuLink
    }, "Quests"), Fortress.hasAccess('resources.admin') && /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: "/resources/admin",
      className: _style["default"].menuLink
    }, "Resources"), (Fortress.hasAccess('shortUrls.admin') || Fortress.hasAccess('shorturls.admin')) && /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: "/shorturls",
      className: _style["default"].menuLink
    }, "Short URLs"), Fortress.hasAnyAccess(['licensing.admin', 'licensing.licenses', 'licensing.courses', 'licensing.logs', 'licensing.vouchers', 'licensing.products']) && /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: "/licensed-products",
      className: _style["default"].menuLink
    }, "Licensed Products"), Fortress.hasAccess('appdefs.admin') && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].divider
    }), /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: "/appdefs/admin/json-editor",
      className: _style["default"].menuLink
    }, "App Settings"))), hasAlertAction && /*#__PURE__*/_react["default"].createElement("a", {
      href: "",
      className: _style["default"].link,
      style: {
        paddingRight: '0.3em'
      },
      onClick: function onClick(e) {
        return e.preventDefault();
      }
    }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement(_AlertButton["default"], {
      render: function render(_ref3) {
        var content = _ref3.content,
          alertCount = _ref3.alertCount;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].alertWrapper
        }, alertCount > 0 && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].alertCounter
        }, Math.min(alertCount, 99)), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].alertContent
          }, content),
          placement: "bottom",
          tippyProps: {
            theme: 'light',
            trigger: 'click',
            interactive: true
          }
        }, /*#__PURE__*/_react["default"].createElement(_bell["default"], null), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)));
      }
    })), additionalIconLinks.map(function (item) {
      var Icon = item.icon;
      if (item.children) {
        return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
          key: item.url + item.handle,
          Icon: Icon,
          position: isCollapse ? 'right' : 'left'
        }, item.children.map(function (child) {
          var ChildIcon = child.icon;
          return /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
            key: child.url + child.handle,
            to: child.url,
            className: (0, _classnames["default"])(_style["default"].menuLink, isActive(child) && _style["default"].active)
          }, ChildIcon && /*#__PURE__*/_react["default"].createElement(ChildIcon, null), child.label);
        }));
      }
      var link = /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
        to: item.url,
        key: item.url + item.handle,
        className: _style["default"].link
      }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement(Icon, null));
      return item.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        key: item.url + item.handle,
        title: item.tooltip,
        tippyProps: {
          delay: [500, null]
        }
      }, link) : link;
    }));
  };
  var renderUserNav = function renderUserNav() {
    if (!props.showUserNav) {
      return null;
    }
    if (Fortress.auth()) {
      var isLoggedAs = Boolean(Fortress.user.loggedInAsAnotherUser);
      var actingRole = AppDefs.pawn.roles.find(function (item) {
        return item.handle === Fortress.user.acting.role.handle;
      });
      var roles = Fortress.user.pawns.filter(function (r) {
        return !['Guest', 'Respondent'].includes(r.name);
      });
      var allowUpdateProfile = !actingRole.disableProfile;
      var allowChangePassword = !actingRole.disableChangePassword;
      var showProfilePassword = allowUpdateProfile || allowChangePassword;
      var greeting = (0, _get2["default"])(AppDefs, 'app.header.greeting', 'Hello,');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].userNav
      }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: Fortress.user.username,
          tippyProps: {
            delay: [500, null],
            touch: false
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(_style["default"].trigger, isLoggedAs && _style["default"].loggedAsAnotherUser),
          "data-user-nav-trigger": Fortress.user.pawnId
        }, isLoggedAs ? /*#__PURE__*/_react["default"].createElement(_users["default"], null) : /*#__PURE__*/_react["default"].createElement(_user["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].longName
        }, function () {
          if (Fortress.user.firstName && greeting) {
            var _long = "".concat(greeting, " ").concat(Fortress.user.firstName, "!");
            var _short = Fortress.user.firstName;
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
              className: "d-none d-sm-inline"
            }, _long), /*#__PURE__*/_react["default"].createElement("span", {
              className: "d-inline d-sm-none"
            }, _short));
          }
          return Fortress.user.username;
        }()), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
          spaceLeft: true
        })))
      }, isLoggedAs && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        className: _style["default"].menuLink,
        onClick: returnToUser
      }, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null), "Back to ", Fortress.user.actualUsername), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].divider
      })), !isLoggedAs && roles.length > 1 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, roles.map(function (pawn) {
        return /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
          key: pawn.id,
          to: "/",
          className: _style["default"].menuLink,
          onClick: function onClick(e) {
            return switchRole(e, pawn.id);
          }
        }, pawn.id === Fortress.user.pawnId ? /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null) : /*#__PURE__*/_react["default"].createElement("svg", {
          viewBox: "0 0 1024 1024"
        }, /*#__PURE__*/_react["default"].createElement("g", null)), pawn.name);
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].divider
      })), !isLoggedAs && Fortress.user.user.auth_type !== 'ldap' && showProfilePassword && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, allowUpdateProfile && /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
        to: "/account/profile",
        className: _style["default"].menuLink
      }, "Update profile"), allowChangePassword && /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
        to: "/account/updatePassword",
        className: _style["default"].menuLink
      }, "Change password"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].divider
      })), /*#__PURE__*/_react["default"].createElement("a", {
        href: Boilerplate.url('/api/user/logout'),
        className: _style["default"].menuLink
      }, /*#__PURE__*/_react["default"].createElement(_exit["default"], null), "Log Out")));
    }

    // registerText, loginText might come from Fortress config (legacy) or Appdefs (current)
    var registerText = '';
    if ((0, _get2["default"])(AppDefs, 'app.selfRegistration.labels.buttonText', null)) {
      registerText = (0, _get2["default"])(AppDefs, 'app.selfRegistration.labels.buttonText');
    } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText', null)) {
      registerText = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText');
    }
    var loginText = '';
    if ((0, _get2["default"])(AppDefs, 'app.login.labels.buttonText', null)) {
      loginText = (0, _get2["default"])(AppDefs, 'app.login.labels.buttonText');
    } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText', null)) {
      loginText = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText');
    }
    var loginButtonText = props.loginButtonText || registerText && loginText && "".concat(registerText, " | ").concat(loginText) || loginText || 'Log In';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].userNav
    }, /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: "/login",
      className: _style["default"].trigger
    }, loginButtonText));
  };
  var renderMobileBar = function renderMobileBar() {
    if (!isCollapse) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].mobileShade,
      style: showMobileBar ? {
        pointerEvents: 'auto',
        opacity: 0.5
      } : {
        pointerEvents: 'none',
        opacity: 0
      },
      onClick: function onClick() {
        return setShowMobileBar(false);
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].mobileBar,
      style: {
        left: showMobileBar ? 0 : '-150%'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].closeButton,
      style: {
        opacity: showMobileBar ? 1 : 0
      },
      onClick: function onClick() {
        return setShowMobileBar(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].mobileContent
    }, Fortress.auth() && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, renderIconNav()), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].divider
    })), primaryNavLinks.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(_MobileLink["default"], {
        key: item.url + item.handle,
        item: item
      });
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].divider
    }), secondaryNavLinks.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(_MobileLink["default"], {
        key: item.url + item.handle,
        item: item
      });
    }))));
  };
  if (isCollapse) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(wrapperClassName, _style["default"].bottomBorder)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: containerClassName
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].header
    }, /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
      to: logoLink,
      className: logoClassName
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].sidebar
    }, renderUserNav(), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: '0.2em 0.5em',
        marginLeft: '-0.5em',
        marginRight: '-0.5em',
        color: isDarkPrimaryNav ? '#eee' : '#666'
      },
      onClick: function onClick() {
        return setShowMobileBar(!showMobileBar);
      }
    }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null)), renderMobileBar()))));
  }
  var hasSecondaryNav = secondaryNavLinks.length > 0;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(wrapperClassName, !hasSecondaryNav && _style["default"].bottomBorder)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClassName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].header
  }, /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], {
    to: logoLink,
    className: logoClassName
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].sidebar
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].primaryNav, actualPrimaryNavLinks.length === 0 && _style["default"].empty, isDarkPrimaryNav && _style["default"].dark),
    ref: primaryBarRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].primaryNavInner
  }, renderNav(actualPrimaryNavLinks))), renderIconNav(), renderUserNav())))), hasSecondaryNav && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].secondaryNav,
    "data-header-secondary-nav": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClassName,
    ref: secondaryBarRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].secondaryNavInner
  }, renderNav(actualSecondaryNavLinks)))), renderSecondaryNavMeter(), renderPrimaryNavMeter());
};
Header.propTypes = {
  /** Wrapper class which could include header background color. */
  wrapperClassName: _propTypes["default"].string,
  /** Container class. One of "container" or "container-fluid". */
  containerClassName: _propTypes["default"].string,
  /** Text to display when no user is logged in */
  loginButtonText: _propTypes["default"].string,
  /** Logo class. Shoul include logo as background image. Could include different logo for mobile. */
  logoClassName: _propTypes["default"].string,
  /** Link to go when clicking on Logo. Could be an app path like "/home" or external link like "https://some.url" */
  logoLink: _propTypes["default"].string,
  /** List of primary links. If it's a string, then it will get list from the appDefs. */
  primaryNavLinks: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),
  /** List of secondary links. If it's a string, then it will get list from the appDefs. */
  secondaryNavLinks: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),
  /** List of additional actions for icons section. */
  additionalIconLinks: _propTypes["default"].array,
  /** Show home action or not? */
  showHomeAction: _propTypes["default"].bool,
  /** Show admin actions or not? */
  showAdminAction: _propTypes["default"].bool,
  /** Show alert action or not? */
  showAlertAction: _propTypes["default"].bool,
  /** Show login, logout, etc links or not? */
  showUserNav: _propTypes["default"].bool,
  /** Is primary nav background dark or not? */
  isDarkPrimaryNav: _propTypes["default"].bool
};
Header.defaultProps = {
  wrapperClassName: _style["default"].wrapperPlaceholder,
  containerClassName: 'container',
  logoClassName: _style["default"].logoPlaceholder,
  logoLink: '/',
  primaryNavLinks: [],
  secondaryNavLinks: [],
  additionalIconLinks: [],
  showHomeAction: true,
  showAdminAction: true,
  showAlertAction: true,
  showUserNav: true,
  isDarkPrimaryNav: false
};
var _default = exports["default"] = Header;